import axios from 'axios'
import { defineStore } from 'pinia'

interface AccountApiResponse {
  isLoggedIn?: boolean
  nexonTag?: string
  [key: string]: unknown
}

interface UserState {
  isLoggedIn: boolean | null
  nexonTag: string
}
export const useUserStore = defineStore('User', {
  state: (): UserState => ({
    isLoggedIn: null,
    nexonTag: '',
  }),
  actions: {
    async getUserInfo(): Promise<void> {
      try {
        const { data } = await axios.get<AccountApiResponse>('/api/account/v1/account')
        this.isLoggedIn = data.isLoggedIn ?? true
        this.nexonTag = data.nexonTag ?? ''
      } catch {
        this.isLoggedIn = false
        this.nexonTag = ''
      }
    },
  },
})
